import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";

const inputCls = "w-full bg-black/50 border border-smasher-gold/25 rounded-xl px-4 py-3 text-white outline-none focus:border-smasher-gold transition";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated", { description: "You can now log in." });
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Reset failed");
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md panel p-8">
        <div className="flex justify-center mb-6"><Logo compact /></div>
        <h1 className="font-heading font-black uppercase text-3xl text-center text-gradient-gold">New Password</h1>
        {!token ? (
          <p className="text-center text-slate-400 mt-6">Invalid or missing reset token.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6" data-testid="reset-form">
            <input type="password" required placeholder="New password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="reset-password" />
            <button className="btn-gold w-full py-3 rounded-xl font-heading font-black tracking-wide" data-testid="reset-submit">UPDATE PASSWORD</button>
          </form>
        )}
        <div className="text-sm mt-4 text-center text-slate-400"><Link to="/login" className="text-smasher-gold hover:text-smasher-orange">Back to login</Link></div>
      </div>
    </div>
  );
}
